import { createRouter, createWebHistory } from "vue-router";
import { ElNotification } from "element-plus";

const routes = [
  {
    path: "/",
    component: () => import("../pages/Index"),
    meta: {
      title: "城南佳苑业委换届选举",
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "城南佳苑业委换届选举";

  if (to.matched.length === 0) {
    ElNotification({
      title: "Error",
      message: `页面 ${to.path} 未找到，已阻止跳转。`,
      type: "error",
      duration: 1500,
    });
    next(false);
    return;
  }

  next();
});

export default router;
